import { MuiGrid } from '@/features/shared/material-ui';
import RichText from '@/features/shared/RichText';
import clsx from 'clsx';
import React, { memo, useMemo } from 'react';
import { DynamicStatsProps } from './DynamicStats.interface';
import useStyles from './DynamicStats.styles';
import { Stat } from './Stat';

const MAX_COLUMNS = 5;
const columnWidth = (quantity = 0) => {
  if (quantity >= MAX_COLUMNS) return { flexBasis: '20%', maxWidth: '20%' };

  const width = `${100 / quantity}%`;
  return { flexBasis: width, maxWidth: width };
};

const DynamicStats = ({
  stats = [],
  groupTitleAndDescription,
  theme,
  contentButtons,
}: Br.PropsWithContentButtons<DynamicStatsProps>) => {
  const classes = useStyles({});
  const multiRowClass = useMemo(
    () => (!groupTitleAndDescription ? classes.gridMultiRow : {}),
    [classes.gridMultiRow, groupTitleAndDescription],
  );
  const rootClasses = clsx(classes.root, `${theme}-theme`);
  const style = React.useMemo(
    () => (!groupTitleAndDescription ? columnWidth(stats.length) : {}),
    [groupTitleAndDescription, stats],
  );

  return (
    <MuiGrid container className={rootClasses}>
      {groupTitleAndDescription && (
        <MuiGrid className={classes.leftGroup} item xs={12} md={4}>
          <RichText theme={theme} content={groupTitleAndDescription} />
        </MuiGrid>
      )}
      <MuiGrid item xs={12} md={groupTitleAndDescription ? 8 : 12}>
        {contentButtons?.content}
        <ul
          className={clsx(
            classes.statsGrid,
            multiRowClass,
            !groupTitleAndDescription ? classes.statsGridNoTitle : null,
          )}
        >
          {stats.map(({ value, description }, id) => (
            <li
              // eslint-disable-next-line react/no-array-index-key
              key={`dynamicStat_${id}`}
              className={clsx(
                classes.gridItem,
                !groupTitleAndDescription ? classes.noTitle : null,
                !description && !value ? classes.gridItemNoMargin : null,
              )}
              style={style}
            >
              <Stat value={value} description={description} theme={theme} />
            </li>
          ))}
        </ul>
      </MuiGrid>
    </MuiGrid>
  );
};

export default memo(DynamicStats);
